import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {ProposalChangeStatus} from '../../../ruleManagement/proposal/mycheck-diff';

const TOOLTIPS: Record<ProposalChangeStatus, string> = {
  changed: 'Geändert von chatBIC',
  added: 'Neu von chatBIC',
  removed: 'Wird von chatBIC gelöscht',
};

/** Tooltip-Text für ein Navigations-Item mit Vorschlags-Änderung; leer (kein Tooltip) ohne Änderung. */
export function proposalNavTooltip(status: ProposalChangeStatus | null | undefined): string {
  return status ? TOOLTIPS[status] : '';
}

/**
 * Marker rechts in einem Navigations-Item der myCheck-Editoren (#2789, Figma „RuleNav“): ein 16×16-Slot
 * mit einem 6×6-Punkt – grün bei geänderten/neuen, rot bei zu löschenden Einträgen.
 *
 * Mit `hasMenu` wird ein projizierter Menü-Trigger (Ellipsis) nur bei Hover über das Nav-Item gezeigt
 * (das Item trägt dafür die Klasse `group`) und ersetzt dann den Punkt; bei offenem Menü (`menuOpen`)
 * bleibt er stehen. Den Tooltip setzt das Nav-Item selbst über {@link proposalNavTooltip}.
 */
@Component({
  selector: 'app-proposal-nav-marker',
  standalone: true,
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {class: 'w-4 h-4 shrink-0 flex items-center justify-center'},
  template: `
    @if (status) {
      <span class="proposal-nav-dot w-1.5 h-1.5 rounded-full"
            [ngClass]="[status === 'removed' ? 'bg-red-600' : 'bg-green-500', hasMenu ? (menuOpen ? 'hidden' : 'group-hover:hidden') : '']"></span>
    }
    @if (hasMenu) {
      <span class="proposal-nav-menu items-center justify-center"
            [ngClass]="[menuOpen ? 'flex' : 'hidden group-hover:flex', status ? 'text-green-500' : 'text-gray-900']">
        <ng-content></ng-content>
      </span>
    }`,
})
export class ProposalNavMarkerComponent {
  @Input() status: ProposalChangeStatus | null = null;
  /** projizierter Menü-Trigger (<ng-content>) erscheint nur bei group-hover bzw. menuOpen */
  @Input() hasMenu = false;
  /** Menü offen → Trigger bleibt sichtbar */
  @Input() menuOpen = false;
}
